import { LogzioTheme } from '@logz-pkg/enums';
import { eventEmitter, EVENTS, LoggerService } from '@logz-pkg/frontend-services';
import { themeService } from './theme.service';
import { themeAppStateService } from 'services/theme/app-state';

const initThemeBridge = (): void => {
  themeService.onThemeChange(async (theme: LogzioTheme) => {
    try {
      await themeAppStateService.set(theme);

      eventEmitter.emit(EVENTS.RELOAD_PRODUCTS);
    } catch (e) {
      LoggerService.logError({ message: 'Theme bridge: Failed to update app state:', error: e });
    }
  });
};

export const themeBridgeService = {
  initThemeBridge,
};
